import { useMemo } from "react";
import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";
import { isStringTrue } from "@iddataweb/idw-common-ui/utils";
import { PreviewEntityTypes } from "@enums/preview-entity-types";
import { FormattedRpServiceConfigurationAttribute } from "@idw-types/data/rp-service-configuration";
import { AXNUIContent } from "@iddataweb/idw-common-ui/types";
import { getComponentForAttribute } from "@utils/attribute-input-util";
import styles from "./axnui-theming-attribute-input-list.less";
import { DEFAULT_AXNUI_CONTENT, DEFAULT_AXNUI_LAYOUT } from "@iddataweb/idw-common-ui/constants";
import { AxnAttributeTypeField, AxnAttributeTypeFieldCustomization } from "@idw-types/data/reference-data/axn";

type AXNUIThemingAttributeInputListProps = {
    attributes: Array<FormattedRpServiceConfigurationAttribute>;
    axnuiContent: AXNUIContent;
    axnAttributeTypeFields: Array<AxnAttributeTypeField>;
    axnAttributeTypeFieldCustomizations: Array<AxnAttributeTypeFieldCustomization>;
    localizeStrings: boolean;
    mergeThemingAndLocalizedFile: boolean;
    activeLanguage: LocaleTypes;
    showAfterCapturePreview: boolean;
    previewEntityType: PreviewEntityTypes;
};

export const AXNUIThemingAttributeInputList = (props: AXNUIThemingAttributeInputListProps) => {
    const {
        attributes,
        axnuiContent,
        axnAttributeTypeFields,
        axnAttributeTypeFieldCustomizations,
        localizeStrings,
        mergeThemingAndLocalizedFile,
        activeLanguage,
        showAfterCapturePreview,
        previewEntityType
    } = props;

    const visibleAttributes = useMemo(() => {
        return attributes.filter(attr => isStringTrue(attr.userVisibleFlag));
    }, [attributes]);

    return (
        <div className={styles.axnuiThemingAttributeInputList}>
            {previewEntityType === PreviewEntityTypes.VERIFICATION_SERVICE && visibleAttributes.map(attribute => (
                <div key={`attribute-input-${attribute.attributeType.id}`}>
                    {getComponentForAttribute(
                        attribute,
                        mergeThemingAndLocalizedFile ? axnuiContent : DEFAULT_AXNUI_CONTENT[activeLanguage],
                        DEFAULT_AXNUI_LAYOUT,
                        axnAttributeTypeFields,
                        axnAttributeTypeFieldCustomizations,
                        localizeStrings,
                        showAfterCapturePreview,
                        activeLanguage
                    )}
                </div>
            ))}
            {previewEntityType === PreviewEntityTypes.WORKFLOW && (
                <div className={styles.previewContainer}>
                    <span>Attributes Section</span>
                    <span>Service related attributes would go here</span>
                </div>
            )}
        </div>
    );
};